import { useApp } from '../../context/AppContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Calendar, Clock, CalendarDays } from 'lucide-react';
import NotificationBell from './NotificationBell';

const Header = ({ title, subtitle }) => {
  const { 
    selectedYear, 
    setSelectedYear, 
    periodType, 
    setPeriodType, 
    selectedPeriod,
    setSelectedPeriod,
    periodBuckets,
    years, 
    periodTypes
  } = useApp();

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-[#E5E7EB] px-4 sm:px-6 py-3 sm:py-0 sm:h-16 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-0">
      <div className="min-w-0">
        <h1 className="text-lg sm:text-xl font-semibold text-[#111827] truncate" data-testid="page-title">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs sm:text-sm text-[#6B7280] truncate">{subtitle}</p>
        )}
      </div>

      <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0 flex-wrap sm:flex-nowrap">
        {/* Year Selector */}
        <div className="flex items-center gap-1.5 sm:gap-2">
          <Calendar className="w-4 h-4 text-[#9CA3AF] hidden sm:block" />
          <Select value={String(selectedYear)} onValueChange={(val) => setSelectedYear(Number(val))}>
            <SelectTrigger className="w-[75px] sm:w-[90px] h-8 sm:h-9 text-xs sm:text-sm border-[#E5E7EB]" data-testid="year-selector">
              <SelectValue placeholder="Year" />
            </SelectTrigger>
            <SelectContent>
              {years.map((year) => (
                <SelectItem key={year} value={String(year)}>
                  {year}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Period Type Selector */}
        <div className="flex items-center gap-1.5 sm:gap-2">
          <Clock className="w-4 h-4 text-[#9CA3AF] hidden sm:block" />
          <Select value={periodType} onValueChange={setPeriodType}>
            <SelectTrigger className="w-[90px] sm:w-[110px] h-8 sm:h-9 text-xs sm:text-sm border-[#E5E7EB]" data-testid="period-type-selector">
              <SelectValue placeholder="Period" />
            </SelectTrigger>
            <SelectContent>
              {periodTypes.map((pt) => (
                <SelectItem key={pt.value} value={pt.value}>
                  {pt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Period Bucket Selector */}
        <div className="flex items-center gap-1.5 sm:gap-2">
          <CalendarDays className="w-4 h-4 text-[#9CA3AF] hidden sm:block" />
          <Select 
            value={selectedPeriod?.id || ''} 
            onValueChange={(val) => {
              const period = periodBuckets.find(p => p.id === val);
              if (period) setSelectedPeriod(period);
            }}
          >
            <SelectTrigger className="w-[140px] sm:w-[220px] h-8 sm:h-9 text-xs sm:text-sm border-[#E5E7EB]" data-testid="period-selector">
              <SelectValue placeholder="Select period">
                {selectedPeriod?.shortLabel || 'Select'}
              </SelectValue>
            </SelectTrigger>
            <SelectContent className="max-h-[300px] overflow-y-auto">
              {periodBuckets.map((period) => (
                <SelectItem key={period.id} value={period.id}>
                  {period.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Notification Bell */}
        <NotificationBell />
      </div>
    </header>
  );
};

export default Header;
